import { message, Table, Upload } from 'antd';
import React, { useState } from 'react'
import { PlusIcon, UploadIcon } from '../../components/Icons/iconImages';
import { Button } from '../../components/Buttons';
import { RcFile, UploadFile } from 'antd/es/upload';

const QuestionTestingMeta: React.FC = () => {
  const [fileList, setFileList] = useState<RcFile[]>([]);
  const [loading, setLoading] = useState(false);

  const uploadProps = {
    beforeUpload: (file: RcFile) => {
      setFileList([file]);
      return false;
    },
    fileList: fileList as UploadFile[],
    onRemove: () => {
      setFileList([]);
    },
    accept: '.xls,.xlsx',
  };

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.warning('Please select a file before uploading');
      return;
    }

    const formData = new FormData();
    formData.append('file', fileList[0]);

    setLoading(true);

    try {
      const response = await fetch(
        `${window.location.origin}/api/v1/meta_questions_testing`,
        { method: 'POST', body: formData }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'File upload failed.');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'meta_questions_result.xlsx';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
      message.success('File uploaded successfully');
    } catch (error) {
      console.error('Upload error:', error);
      const errMsg = error instanceof Error ? error.message : 'File upload failed. Please try again.';
      message.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-[88vh] flex items-center justify-center">
      <div className="bg-gray-100 p-6 rounded-2xl shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-semibold mb-4 text-center">
          Upload Excel File for Question Testing | META
        </h2>
        <Upload {...uploadProps} className="mb-4">
          <Button icon={<UploadIcon />}>Select Excel File</Button>
        </Upload>
        {fileList.length > 0 && (
          <div className="mb-4 text-sm text-gray-600">
            Selected file: <strong>{fileList[0].name}</strong>
          </div>
        )}
        <Button
          type="primary"
          block
          onClick={handleUpload}
          loading={loading}
          disabled={loading}
          className="mt-4"
        >
          {loading ? 'Generating file...' : 'Upload'}
        </Button>
        {loading && (
          <p className="mt-2 text-center text-sm text-gray-500">
            Please wait while we process your file...
          </p>
        )}
      </div>
    </div>
  );
};



export default QuestionTestingMeta